import timeGridPlugin from '@fullcalendar/timegrid'; // a plugin!
import interactionPlugin from '@fullcalendar/interaction';
import momentPlugin from '@fullcalendar/moment';
import { datesConverter } from './datesConvertToFCFormat';
export default function getFCDesktopOptions(_a) {
    var isResponsive = _a.isResponsive, isCurrentTimeShown = _a.isCurrentTimeShown, is24format = _a.is24format, timezone = _a.timezone, dates = _a.dates, isPrivateEventsShown = _a.isPrivateEventsShown, locale = _a.locale, firstDay = _a.firstDay, 
    // recurrenceArr,
    isMobile = _a.isMobile;
    var settings = {
        //base settings
        plugins: [timeGridPlugin, interactionPlugin, momentPlugin],
        initialView: isMobile ? 'timeGridDay' : 'timeGridWeek',
        events: dates &&
            datesConverter(dates, timezone, isPrivateEventsShown),
        dayHeaders: false,
        headerToolbar: false,
        slotEventOverlap: false,
        allDayText: '',
        scrollTime: '07:40:00',
        slotMinTime: isResponsive ? '00:00:00' : '07:00:00',
        slotMaxTime: isResponsive ? '24:00:00' : '23:00:00',
        eventInteractive: true,
        //Settings from props
        locale: locale,
        firstDay: firstDay,
        timeZone: timezone,
        nowIndicator: isCurrentTimeShown,
        slotLabelFormat: {
            hour: 'numeric',
            minute: '2-digit',
            omitZeroMinute: !is24format,
            hour12: !is24format,
        },
    };
    if (!isMobile) {
        // @ts-ignore
        settings.slotDuration = '01:00:00';
    }
    return settings;
}
//# sourceMappingURL=getFCOptions.js.map